import { useEffect, useState } from "react";
import { Row, Col, Card, Alert } from "antd";
import {
  UserOutlined,
  DollarOutlined,
  FormOutlined,
  BellOutlined,
} from "@ant-design/icons";
import RevenueChart from "./RevenueCharts";
import LatestActivities from "./LatestActivities";
import LatestPayments from "./LatestPayments";
import adminService from "../../../../services/adminService";
import LoadingSpinner from "../../../UI/LoadingSpinner";

const AdminHome = () => {
  const [metricData, setMetricData] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const response = await adminService.getAdminMetrics();
      setMetricData(response);
      setLoading(false);
    };
    getData();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      {loading && <LoadingSpinner />}
      {/* Einnahmen */}
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <div className="flex items-center">
              <DollarOutlined className="text-3xl text-green-500 mr-4" />
              <div>
                <p className="text-sm text-gray-500">Monatliche Einnahmen</p>
                <p className="text-2xl font-semibold">
                  {metricData?.monthlyRevenue}
                </p>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <div className="flex items-center">
              <DollarOutlined className="text-3xl text-blue-500 mr-4" />
              <div>
                <p className="text-sm text-gray-500">Gesamtumsatz</p>
                <p className="text-2xl font-semibold">
                  {metricData?.totalRevenue}
                </p>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card title="Letzte Zahlungen">
            <LatestPayments latestPayments={metricData?.latestPayments} />
          </Card>
        </Col>
      </Row>

      {/* Nutzerstatistiken */}
      <Row gutter={[16, 16]} className="mt-6">
        <Col xs={24} sm={12} md={8}>
          <Card>
            <div className="flex items-center">
              <UserOutlined className="text-3xl text-purple-500 mr-4" />
              <div>
                <p className="text-sm text-gray-500">Gesamtanzahl Nutzer</p>
                <p className="text-2xl font-semibold">
                  {metricData?.totalUsers}
                </p>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <div className="flex items-center">
              <UserOutlined className="text-3xl text-orange-500 mr-4" />
              <div>
                <p className="text-sm text-gray-500">
                  Neue Nutzer (letzter Monat)
                </p>
                <p className="text-2xl font-semibold">{metricData?.newUsers}</p>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card>
            <div className="flex items-center">
              <UserOutlined className="text-3xl text-cyan-500 mr-4" />
              <div>
                <p className="text-sm text-gray-500">Aktive Nutzer</p>
                <p className="text-2xl font-semibold">
                  {metricData?.activeUsers}
                </p>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Feedback-Formulare */}
      <Row gutter={[16, 16]} className="mt-6">
        <Col xs={24} md={12}>
          <Card>
            <div className="flex items-center">
              <FormOutlined className="text-3xl text-indigo-500 mr-4" />
              <div>
                <p className="text-sm text-gray-500">Erstellte Formulare</p>
                <p className="text-2xl font-semibold">
                  {metricData?.totalForms}
                </p>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card>
            <div className="flex items-center">
              <FormOutlined className="text-3xl text-pink-500 mr-4" />
              <div>
                <p className="text-sm text-gray-500">
                  Abgeschlossene Feedbacks
                </p>
                <p className="text-2xl font-semibold">
                  {metricData?.completedForms}
                </p>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Einnahmen-Chart und Letzte Aktivitäten */}
      <Row gutter={[16, 16]} className="mt-6">
        <Col xs={24} lg={16}>
          <Card title="Monatliche Einnahmen">
            <RevenueChart
              monthlyRevenueByMonth={metricData?.monthlyRevenueByMonth || []}
            />
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card title="Letzte Aktivitäten">
            <LatestActivities activities={metricData?.activities || []} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminHome;
